// biome-ignore lint/style/useNamingConvention: __DEV__ is a Metro-injected global
declare const __DEV__: boolean | undefined;

export type AppEnvType = 'local' | 'dev' | 'stg' | 'prod';

export function getAppEnv(): AppEnvType {
  if (typeof __DEV__ !== 'undefined') {
    return __DEV__ ? 'local' : 'prod';
  }

  const fromWindow = readFromWindow();
  if (fromWindow) {
    return fromWindow as AppEnvType;
  }

  if (typeof process === 'undefined' || !process.env) {
    throw new Error('APP_ENV is not set and process.env is unavailable');
  }

  if (process.env.APP_ENV) {
    return process.env.APP_ENV as AppEnvType;
  }

  if (process.env.NEXT_PUBLIC_APP_ENV) {
    return process.env.NEXT_PUBLIC_APP_ENV as AppEnvType;
  }

  if (process.env.CI) {
    return 'local';
  }

  throw new Error('APP_ENV is not set');
}

function readFromWindow(): string {
  if (typeof globalThis === 'undefined') {
    return '';
  }
  // biome-ignore lint/style/useNamingConvention: injected by the Telegram worker into window
  const injected = (globalThis as { __APP_ENV__?: unknown }).__APP_ENV__;
  return typeof injected === 'string' ? injected : '';
}
